<template>
  <div
    v-if="modelType"
    class="group flex flex-col rounded-[12px] font-roboto text-new-black shadow-none"
  >
    <div
      class="rounded-xl p-4 shadow-drop-2"
      :class="{ 'flex w-full': !isTile }"
    >
      <MainPageCardsReworkedCommonCardImageBlock
        v-if="isTile"
        disable-label
        v-bind="{ data }"
        :aspect="aspect"
        class="relative w-full"
      >
        <div
          class="absolute inset-x-0 bottom-0 z-40 flex h-[18%] max-h-[28px] items-center justify-between bg-[#460B0F80] px-3"
        >
          <SvgIcon
            :name="`teacher/${modelType}`"
            class="size-4 text-white-100"
          />
          <span
            v-if="modelType === 'test'"
            class="text-[12px] font-medium leading-[14px] text-white-100"
          >
            {{ data[getContentCount('test_q')] }}
            {{
              contentTime(
                data[getContentCount('test_q')],
                getContentText('test_q'),
              )
            }}
          </span>
        </div>
      </MainPageCardsReworkedCommonCardImageBlock>
      <div class="flex flex-col">
        <div
          v-if="categoryTitle"
          class="w-fit rounded-md bg-[#A100090F] px-2 py-1.5 text-[12px] leading-[14px] text-specialprojectsection"
          :class="{ 'mt-4': isTile }"
        >
          {{ scoolClass.title }} | {{ categoryTitle }}
        </div>
        <div class="tooltip mt-2 flex">
          <MainPageCardsReworkedTeacherContentSrcIcon
            v-if="data?.entity_source && data.entity_source.id !== 2"
            :link="data.entity_source.url"
            class="mr-1.5 mt-[3px] size-4 shrink-0"
          />
          <div
            ref="wrapContentSizeRef"
            :class="{ 'text-clamp-2': isHiddenText && isHorizontalPadOrMore }"
            class="min-h-[44px] overflow-hidden lg:h-11"
          >
            <h2
              ref="textContentSizeRef"
              class="font-roboto text-[16px] font-medium leading-[22px]"
            >
              {{ data?.title }}
            </h2>
          </div>
          <div
            v-show="isHiddenText && isHorizontalPadOrMore"
            class="tooltiptext card-left"
          >
            {{ data?.title }}
          </div>
        </div>
        <div
          v-if="getTimeForModel(modelType, data)"
          class="mt-3 flex min-h-[14px] items-center text-[14px] font-medium leading-[24px] text-ruby-red-100"
        >
          <SvgIcon name="clock" class="size-5 min-h-[20px] min-w-[20px]" />
          <span class="ml-1">{{ getTimeForModel(modelType, data) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
    require: true,
  },
  aspect: {
    type: Object,
    default: () => ({
      w: 258,
      h: 145,
    }),
  },
  categoryTitle: {
    type: String,
    default: '',
  },
  isTile: {
    type: Boolean,
    default: true,
  },
  scoolClass: {
    type: Object,
    default: () => ({}),
  },
});

const { contentTime, getTimeForModel, getContentCount, getContentText } =
  useTimeForModel();

const { isHorizontalPadOrMore } = useBreakpoint();

const modelType = computed(() => props.data?.model_type);

const isHiddenText = ref(false);
const wrapContentSizeRef = ref(null);
const textContentSizeRef = ref(null);

onMounted(() => {
  setTimeout(() => {
    isHiddenText.value =
      textContentSizeRef.value?.getBoundingClientRect().height >
      wrapContentSizeRef.value?.getBoundingClientRect().height;
  });
});
</script>
